<template>
  <div class="tr-step-3">
    <div class="step3B__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <!-- wwr window table -->
      <Highlight3B />
      <!-- window type table -->
    </div>
    <div class="tr-step-3__card">
      <div class="tr-step-3B__mainHead">STEP:3 Openable Area Details</div>
      <div class="tr-step-3B__subHead">
        <v-icon>mdi-window-closed-variant</v-icon>

        (B) Openable Area Window
      </div>

      <div>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in openableAreaWindowSteps" :key="i" :style="{ margin: '4px' }">
            <v-expansion-panel-header>{{ item }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="step-3B__accordian-fields-wrap">
                <div class="step-3B__accordian-fields-row">
                  <!--Wall Surface Area Table -->
                  <div
                    v-if="
                      item ===
                        `Window to wall 
ratio (WWR %)`
                    "
                  >
                    <WwrTable3B />
                  </div>
                  <div v-else-if="item === 'Window Type'">
                    <window-type-table-3-b />
                  </div>
                  <div v-else-if="item === 'Openable Area'">
                    <window-openable-area-3-b />
                  </div>
                  <div v-else-if="item === 'Glass Area'">
                    <WindowGlassAreaTable3B />
                  </div>
                  <div v-else-if="item === 'Opaque Area'">
                    <WindowOpaqueAreaTable3B />
                  </div>
                  <!-- <data-table-vuetify /> -->
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="step-3B__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step3A' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step3C' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import WwrTable3B from '../tables/step3B/WwrTable3B.vue';
import WindowTypeTable3B from '../tables/step3B/WindowTypeTable3B.vue';
import WindowOpenableArea3B from '../tables/step3B/WindowOpenableAreaTable3B.vue';
import WindowGlassAreaTable3B from '../tables/step3B/WindowGlassAreaTable3B.vue';
import WindowOpaqueAreaTable3B from '../tables/step3B/WindowOpaqueAreaTable3B.vue';
import Highlight3B from '../highlights/Highlight3B.vue';
export default {
  components: {
    WwrTable3B,
    WindowTypeTable3B,
    WindowOpenableArea3B,
    WindowGlassAreaTable3B,
    WindowOpaqueAreaTable3B,
    Highlight3B,
  },
  data() {
    return {
      openableAreaWindowSteps: [
        `Window to wall 
ratio (WWR %)`,
        'Window Type',
        'Openable Area',
        'Glass Area',
        'Opaque Area',
      ],
    };
  },
  computed: {
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(Step3B) {
        this.$store.dispatch('setStep3B', Step3B);
      },
    },
  },
};
</script>

<style lang="scss">
.tr-step-3 {
  padding: 32px;
  width: 100%;
  height: 100%;
}
.step3B__highlight-card {
  background-color: #fff;
  margin: 24px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}

.tr-step-3__card {
  background-color: #fff;
  padding: 38px;
  // width: 80%;
}
.tr-step-3B__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step-3B__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}
.step-3B__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step-3B__next-back-row {
  display: flex;
  justify-content: space-between;
}
</style>
